/* istanbul ignore file */
export * from './RatingPageHead';
